import { BRANDS_DATA } from "constants/action-types";
import type { IRequestDataAction } from "epics/base-epic";
import { stringify } from "querystring";

export type IFetchBrandsDataActionPayload = IRequestDataAction<{}>;

export interface IFetchBrandsDataPayload {
    query?: { assortment_brands_only: true };
    fields?: string[];
}

/**
 * High performant request to fetch all brands.
 * Stores small amount of fields like `_id`, `name`, `active`.
 * For assortments it also stores `modules.assortment.active` field.
 *
 * @note use it only if you need to display a lot of brands. Brands stored here do **not** have `permissions` or other data.
 */
export const fetchBrandsData = (
    payload: IFetchBrandsDataPayload
): { type: string; payload: IFetchBrandsDataActionPayload } => ({
    type: BRANDS_DATA.FETCH.START,
    payload: {
        url: `/api/v3.0/brands/list?${stringify(payload.query)}`,
        body: null,
    },
});
